export default __webpack_public_path__ + "static/media/download.d7c9ab8d.svg";